import SimpleDataWithVariation from '@/language/pt/components/cards/models/SimpleDataWithVariation';
import CardWithTitle from '@/language/pt/components/cards/models/CardWithTitle';
import PieChart from '@/language/pt/components/cards/models/PieChart';
import TogglePieChart from '@/language/pt/components/cards/models/TogglePieChart';
import BubbleChart from '@/language/pt/components/cards/models/BubbleChart';
import CardChart from '@/language/pt/components/cards/models/CardChart';
import InputController from '@/language/pt/components/cards/models/InputController';
import LineChart from '@/language/pt/components/cards/models/LineChart';
import TermGraph from '@/language/pt/components/cards/models/TermGraph';
import Feed from '@/language/pt/components/cards/models/Feed';
import CustomLineChart from '@/language/pt/components/cards/models/CustomLineChart';
import CardOptions from '@/language/pt/components/cards/models/CardOptions';

export default {
  SimpleDataWithVariation,
  CardWithTitle,
  PieChart,
  TogglePieChart,
  BubbleChart,
  CardChart,
  InputController,
  LineChart,
  TermGraph,
  Feed,
  CustomLineChart,
  CardOptions,
};
